module.exports = __webpack_public_path__ + "node_modules/font-awesome/fonts/fontawesome-webfont.svg";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = 163
// module chunks = 0